"use client";

import React from "react";
import { Button } from "../../../components/ui/button";
import {
  Compass,
  ArrowRight,
} from "lucide-react";
import { useRouter } from "next/navigation";

const Page = () => {
  const router = useRouter();
  const handleClick = () => {
    router.push("/trails");
  };
  return (
    <section className="bg-white text-[#0D0D0D] py-10 px-6 sm:px-10 lg:px-24 mx-auto ">
      <div className="space-y-10">
        <div className="text-center space-y-6">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Compass className="w-8 h-8 text-[#FFAE00]" />
            <h1 className="text-4xl sm:text-5xl font-bricolage font-medium text-[#FFAE00]">
              Vision & Values
            </h1>
          </div>
        </div>

        <div className="border-l-4 border-[#FFAE00] pl-6 mb-8 space-y-6">
          <div>
            <h2 className="text-2xl sm:text-3xl text-[#0D0D0D] font-medium font-bricolage mb-4">
              1. Travel With Purpose
            </h2>
            <p className="text-lg leading-relaxed font-jakarta">
              We journey not to tick boxes on a map but to gather insights, ideas, and fresh purpose. Every Outcome Outing trip is designed to enrich minds and spark possibilities — because exploration without intention is simply tourism, and we are here for transformation.
            </p>
          </div>

          <div>
            <h2 className="text-2xl sm:text-3xl text-[#0D0D0D] font-medium font-bricolage mb-4">
              2. Outcome-Driven Experiences
            </h2>
            <p className="text-lg leading-relaxed font-jakarta">
              Outcomes are our compass. Whether it’s clarity on a career pivot, a business breakthrough, or a personal realization, our adventures are woven with learning opportunities designed to generate tangible takeaways — not just memories, but milestones.
            </p>
          </div>

          <div>
            <h2 className="text-2xl sm:text-3xl text-[#0D0D0D] font-medium font-bricolage mb-4">
              3. The Entrepreneurial Spirit
            </h2>
            <p className="text-lg leading-relaxed font-jakarta">
              We believe the world needs more creators, builders, and bold thinkers. Many of our experiences are rooted in entrepreneurship — sparking fresh ideas, fueling risk-taking courage, and connecting visionaries who dare to shape tomorrow.
            </p>
          </div>

          <div>
            <h2 className="text-2xl sm:text-3xl text-[#0D0D0D] font-medium font-bricolage mb-4">
              4. Learning Through Exploration
            </h2>
            <p className="text-lg leading-relaxed font-jakarta">
              Every journey is a classroom. From serene mountain peaks to bustling village markets, we see the world as a living textbook — teaching us patience, problem-solving, adaptability, and cultural intelligence. For us, exploration is the highest form of education.
            </p>
          </div>

          <div>
            <h2 className="text-2xl sm:text-3xl text-[#0D0D0D] font-medium font-bricolage mb-4">
              5. Curated Connections
            </h2>
            <p className="text-lg leading-relaxed font-jakarta">
              We don’t gather tourists; we curate tribes. Outcome Outing is a space where like-minded souls — founders, creators, dreamers, misfits — come together to share stories, offer wisdom, and grow through shared experience. These connections last far beyond the trip itself.
            </p>
          </div>

          <div>
            <h2 className="text-2xl sm:text-3xl text-[#0D0D0D] font-medium font-bricolage mb-4">
              6. Authenticity Above All
            </h2>
            <p className="text-lg leading-relaxed font-jakarta">
              We don’t believe in surface-level sightseeing. Our journeys dive deep — into local cultures, real conversations, and raw, authentic experiences that spark inner change.
            </p>
          </div>
        </div>

        {/* Call to Action */}
        <div className="flex justify-center w-full pt-8">
          <Button
            variant="default"
            className="font-jakarta font-semibold text-white bg-[#FFAE00] hover:bg-[#FFAE00]/90 text-lg px-8 py-3 rounded-xl transition-all duration-200 flex items-center gap-2 group"
            onClick={handleClick}
          >
            Explore Experiences
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Page;
